import React from 'react';
import { StarIcon, UsersIcon, FileTextIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="py-10 bg-white border-b border-gray-100" data-id="element-173">
      <div className="max-w-4xl mx-auto px-4" data-id="element-174">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-175">
          <div className="flex flex-col items-center p-4 rounded-2xl bg-blue-50" data-id="element-176">
            <FileTextIcon className="w-10 h-10 text-blue-600 mb-3" data-id="element-177" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-178">300+</h3>
            <p className="text-gray-600 font-medium" data-id="element-179">Risorse digitali pronte</p>
          </div>
          <div className="flex flex-col items-center p-4 rounded-2xl bg-orange-50" data-id="element-180">
            <UsersIcon className="w-10 h-10 text-orange-500 mb-3" data-id="element-181" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-182">Migliaia</h3>
            <p className="text-gray-600 font-medium" data-id="element-183">
              Di insegnanti soddisfatti
            </p>
          </div>
          <div className="flex flex-col items-center p-4 rounded-2xl bg-green-50" data-id="element-184">
            <StarIcon className="w-10 h-10 text-green-500 mb-3 fill-current" data-id="element-185" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-186">4.9/5</h3>
            <p className="text-gray-600 font-medium" data-id="element-187">Valutazione media</p>
          </div>
        </div>
      </div>
    </section>;
}